if ($('#app-avail_proposals-table').length) {
    var data_table_order = [0, "desc"];
    var app_avail_proposals_table_all = $('#app-avail_proposals-table').DataTable({
        "processing": true,
        "serverSide": true,
        ajax: {
            url: '/avail_proposal/index',
            dataSrc: 'data',
        },
        // headers: {
        //     'Accept': 'application/json'
        // }
        order: [0, "desc"],
        columns: [
            {data: 'id'},//0
            {data: 'name'},//1
            {data: 'market'},//2
            {data: 'vendors'},//3
            {data: 'rate_type'},//4
            {data: 'date_start'},//5
            {data: 'date_end'},//6
            {data: 'created_at_format'},//7
            {data: 'id'} //8
        ],
        // destroy: true,
        pageLength: user_entries,
        "columnDefs": [
            {
                "targets": 0,
                "visible": true,
                "orderable": false,
                "className": "text-center",
                "createdCell": function (td, cellData, rowData, row, col) {
                    var html = ' <div class="checkbox checkbox-danger avail_proposal_check"> <input class="checkbox" class="form-control" type="checkbox"  id="' + rowData.id + '" name="selected_avail_proposals[]" value="' + rowData.id + '" ><label for="' + rowData.id + '"> </label></div>';
                    $(td).html(html);
                }
            },
            {
                "targets": 1,
                "orderable": true,
                "visible": true,
            },
            {
                "targets": 2,
                "orderable": true,
            },
            {
                "targets": 3,
                "orderable": true,
            },
            {
                "targets": 4,
                "orderable": true,
                "visible": false,
            },
            {
                "targets": 5,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(moment(cellData).format('MM/DD/YYYY'));
                }
            },
            {
                "targets": 6,
                "orderable": true,
                "createdCell": function (td, cellData, rowData, row, col) {
                    $(td).html(moment(cellData).format('MM/DD/YYYY'));
                }
            },
            {
                "targets": 7,
                "orderable": true,
            },
            {
                "targets": 8,
                "orderable": false,
                "createdCell": function (td, cellData, rowData, row, col) {
                    console.log('rowData', rowData)
                    var html = '';
                    var auxHtml = '';
                    var html = '<div class="btn-group">\n' +
                        '            <button type="button" class="btn btn-outline btn-success waves-effect waves-light m-r-5 btn-off" data-toggle="dropdown">\n' +
                        '                <i class="fa fa-ellipsis-v"></i>\n' +
                        '                <span class="sr-only">Toggle Dropdown</span>\n' +
                        '            </button>\n' +
                        '            <ul class="dropdown-menu dropdown-menu-right">\n' +
                        '                             <li class="ms-hover">' + '<a class="populate-avail-proposal" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + cellData + '" >' + '<i class="fa fa-paper-plane"></i> Post Proposal' + '</a>' + '</li>' +
                        '                             <li class="ms-hover">' + '<a class="download-avail-proposal" href="javascript:void(0)" data-name="' + rowData.name + '" data-id="' + cellData + '" >' + '<i class="fa fa-cloud-download"></i> Download File' + '</a>' + '</li>' +
                        '  </ul>\n' +
                        '  </div>';

                    $(td).html(html);
                }
            }
        ]
    });

    $('#app-avail_proposals-table').on( 'length.dt', function ( e, settings, len ) {
        user_entries = len;
    });
    $('#app-avail_proposals-table').on( 'order.dt', function ( e, settings, len) {
        data_table_order = [len[0].col, ""+len[0].dir+""];
    });

    $('#select_all_buyer_agencies').on('click', function (e) {
        $('#app-avail_proposals-table input:checkbox').prop('checked', true);
    });
    $('#deselect_all_buyer_agencies').on('click', function (e) {
        $('#app-avail_proposals-table input:checkbox').prop('checked', false);
    });

    $('#app-avail_proposals-table').on('click','.populate-avail-proposal', function () {
        var proposals = [$(this).attr('data-id')];
       show_buyer_agencies_list(proposals);
    });
    $('#populate_proposals').on('click', function () {
        var proposals = [];
        $('.avail_proposal_check input[type=checkbox]').each(function () {
            if (this.checked)
                proposals.push($(this).val());
        });
        if(proposals.length > 0)
          show_buyer_agencies_list(proposals);
        else
            swal({
                    title: 'Warning!',
                    text: 'Please selecte at least one proposal.',
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "Ok",
                    cancelButtonText: "Cancel",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {});
    });

    var sendProposalAPIColumnDef = [];
    var sendProposalAPIGrid;
    function show_buyer_agencies_list(proposals) {
        sendProposalAPIColumnDef = [
            {
                field: 'proposal_id',
                headerName: "Proposal Name",
                width: 400,
                rowGroupIndex: 0,
                hide: true,
                groupSelectsChildren: true,
                cellRenderer: function (params) {
                    var html = '';
                    if (params.node.level == 0)
                        $.each(params.node.childrenAfterFilter, function (index, value) {
                              html += "<span style='margin-bottom: 20%'>" + value.data.proposal_name + "</span>";
                        });

                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    this.eGui = tempDiv.firstElementChild;
                    return this.eGui;
                },
            },
            {
                field: 'line_id',
                headerName: 'Buyer_Agency',
                groupSelectsChildren: true,
                sort: 'asc',
                width: 300,
                icons: {
                    menu: '<i class="fa fa-bars fa-lg"/>',
                },
                checkboxSelection: function (params) {
                    return typeof params.data !== 'undefined' && parseInt(params.data.posted) === 0 ? true : false;
                },
                cellRenderer: function (params) {
                    var spam = typeof params.node !== 'undefined' && typeof params.node.data !== 'undefined' && parseInt(params.node.data.posted) === 1 ? "<i class='fa fa-check' style='color: darkred'></i>  " : "";
                    var style = typeof params.node !== 'undefined' && typeof params.node.data !== 'undefined' && parseInt(params.node.data.posted) === 1 ? " ;margin-left: 5%" : "";
                    var html = typeof params.node !== 'undefined' && typeof params.node.data !== 'undefined' ? "<span style='margin-bottom: 20% "+ style +"'>" + spam + "" + params.node.data.buyer_agency_name + "</span>" : '';
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = html;
                    this.eGui = tempDiv.firstElementChild;
                    return this.eGui;
                },
            },
            {
                field: 'posted_at',
                headerName: "Posted At",
                width: 150,
                cellStyle: {'text-align': "left"},
            },
            {
                field: 'pulled_from_buyer',
                headerName: "Pulled At",
                width: 150,
                cellStyle: {'text-align': "left"},
            },
            {
                field: 'accepted_at',
                headerName: "Accepted At",
                width: 150,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
            {
                field: 'declined_at',
                headerName: "Declined At",
                width: 150,
                cellStyle: {'text-align': "left"},
                hide: true,
            },
        ];
        sendProposalAPIGrid = {
            columnDefs: sendProposalAPIColumnDef,
            sideBar: false,
            autoGroupColumnDef: {
                cellRenderer: 'agGroupCellRenderer',
                headerName: 'Select/Deselect All',//custom header name for group
                pinned: 'left',//force pinned left. Does not work in columnDef
                suppressMovable: true,
                suppressFilter: false,
                cellRendererParams: {
                    suppressCount: true,//remove number in Group Column
                    suppressMovable: true,
                    suppressFilter: false,
                    checkbox: true,
                    headerCheckbox: true,
                    headerCheckboxSelection: true,
                    cellRenderer: 'agGroupCellRenderer',
                },
                width: 300,
                max_width: 500,
                pinned: 'left',
                suppressFilter: true,
                headerCheckbox: true,
                headerCheckboxSelection: true,
            },
            enableColResize: true,
            suppressTouch: true,
            headerHeight: 25,
            suppressDragLeaveHidesColumns: true,
            enableCellChangeFlash: true,
            rowHeight: 20,
            /*toolPanelSuppressValues: true,*/
            defaultToolPanel: '',
            suppressRowHoverHighlight: true,
            suppressParentsInRowNodes: true,
            groupUseEntireRow: false,
            groupDefaultExpanded: 1,
            rowSelection: 'multiple',
            rowMultiSelectWithClick: true,
            groupSelectsChildren: true,
            suppressRowClickSelection: true,
            suppressAggFuncInHeader: true,
            enableFilter: true,
            enableSorting: true,
            animateRows: true,
            //marryChildren: true,
            icons: {
                groupExpanded: '<i class="fa fa-angle-double-down"></i>',
                groupContracted: '<i class="fa fa-angle-double-right"></i>',
                menu: '<i class="fa fa-bars fa-lg"/>',
                sortAscending: '<i class="fa fa-caret-down"/>',
                sortDescending: '<i class="fa fa-caret-up"/>',
                columnMoveMove: '<i class="fa fa-arrows"></i>',
                columnMovePin: '<i class="fa fa-thumb-tack"></i>',
                columnMoveLeft: '<i class="fa fa-arrow-left"></i>',
                columnMoveRight: '<i class="fa fa-arrow-right"></i>',
                columnMoveHide: '<i class="fa fa-remove"/>'
            },


        };
        var params = { proposals: [],};
        for(var i in proposals)
            params.proposals.push(proposals[i]);
        $.ajax({
            type: 'POST',
            url: '/avail_proposals/get/buyer_agencies',
            data: JSON.stringify(params),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            traditional: true,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                sendProposalAPIGrid.rowData = [];
                sendProposalAPIGrid.rowData = data;
                $('#sendProposalAPIGridDiv').html("");
                var sendProposalAPIGridGrid = document.querySelector('#sendProposalAPIGridDiv');
                var g5 = new agGrid.Grid(sendProposalAPIGridGrid, sendProposalAPIGrid);
                $('#SendProposalAPIModal').modal('show');
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });

    }
    function onFilterTextBoxChangedBuyerAgencyAPI() {
        sendProposalAPIGrid.api.setQuickFilter(document.getElementById('keywordsFilterBuyerAgencyAPI').value);
    }
    $('#select_ba_api_all').on('click', function (){
        sendProposalAPIGrid.api.selectAllFiltered();
    });
    $('#deselect_ba_api_all').on('click', function (){
        sendProposalAPIGrid.api.deselectAll();
    });

    $('#final_send_proposal_buyer_agency_by_api').on('click', function (){
        if(sendProposalAPIGrid.api.getSelectedNodes().length > 0){
            show_overlay_loader("#SendProposalAPIModal");
            var request = {
                'lines': [],
            };

            for(var i in sendProposalAPIGrid.api.getSelectedNodes()) {
                console.log('sendProposalAPIGrid', sendProposalAPIGrid.api.getSelectedNodes()[i])
                if(parseInt(sendProposalAPIGrid.api.getSelectedNodes()[i].data.posted) === 0)
                   request.lines.push(sendProposalAPIGrid.api.getSelectedNodes()[i].data)
            }
            if(request.lines.length > 0)
              $.ajax({
                type: 'POST',
                url: '/avail_proposals/post',
                data: JSON.stringify(request),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                traditional: true,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                success: function (data) {
                    global_notification('success', "Proposal posted...");
                    $("#SendProposalAPIModal").modal('hide');
                    hide_overlay_loader("#SendProposalAPIModal");
                },
                error: function (xhr) {
                    ajax_error();
                    debug(xhr.responseText);
                    hide_overlay_loader("#SendProposalAPIModal");
                }
            });
            else {
                hide_overlay_loader("#SendProposalAPIModal");
                global_notification('warning', "Please select at least one Proposal/Buyer Agency no posted...");
            }
        }else
            global_notification('warning', "Please select at least one Buyer Agency...");
    });

    $('#app-avail_proposals-table').on('click','.download-avail-proposal', function () {
        show_loader();
        var proposal_id = $(this).attr('data-id');
        $.ajax({
            type: 'GET',
            url: '/avail_proposal/download/file/' + proposal_id,
            dataType: 'json',
            encode: true,
            success: function (data) {
                var path = data.path;
                var a = $("<a style='display: none;'/>");
                var url = path;
                a.attr("href", url);
                a.attr("download", data['file_name']);
                $("body").append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
                hide_loader();
            },
            error: function (xhr) {
                hide_loader();
                ajax_error();
                debug(xhr.responseText);
            }
        });
    });

}